import { iconBaseProps, type IconProps } from "@/components/ui/icons/icon-base"

export const SortIcon = ({ size = 16, ...props }: IconProps) => (
  <svg {...iconBaseProps(size, props)} fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M7 4v16M3 17l4 4 4-4M17 20V4M13 7l4-4 4 4" />
  </svg>
)
